import { useRouter } from 'next/router';
import { useMemo } from 'react';

const getOrigin = () => {
  if (process.env.NEXT_PUBLIC_BASE_URL.startsWith('http')) {
    return process.env.NEXT_PUBLIC_BASE_URL;
  }

  return `https://${process.env.NEXT_PUBLIC_BASE_URL}`;
};

export const useRouterParams = () => {
  const router = useRouter();

  return useMemo(() => {
    const url = new URL(router.asPath, getOrigin());

    return url.searchParams.entries()
      .reduce((acc, [key, value]) => {
        acc[key] = value;

        return acc;
      }, {} as Record<string, string | undefined>);
  }, [router.asPath]);
};
